import { DeletableItem } from 'taboola-ultimate-ui';
import { Divider } from 'taboola-ultimate-ui';
import { useFilters } from 'modules/push-api/hooks/useFilters';
import { FormNamespaceProvider } from 'modules/taboola-common-frontend-modules/formData/FormNamespaceProvider';
import { AndOrToggle } from '../AndOrToggle/AndOrToggle';
import { SubscriptionAddItemButton } from '../SubscriptionAddItemButton/SubscriptionAddItemButton';
import { SubscriptionFilter } from '../SubscriptionFilter/SubscriptionFilter';
import styles from './subscriptionField.module.scss';

export const SubscriptionField = ({ itemKey, entityIndex, fieldIndex }) => {
    const { filters, addFilter, deleteFilter } = useFilters();

    return (
        <div className={styles['filter']}>
            <div className={styles['filter-header-columns']}>
                <div className={styles['filter-header']}>
                    <AndOrToggle />
                    Operator between filters
                </div>
                <Divider />
            </div>
            <div className={styles['filters']}>
                <FormNamespaceProvider field="filters" itemKey={itemKey}>
                    {filters?.map(({ id: key }, index) => {
                        return (
                            <FormNamespaceProvider field={index} itemKey={key} key={`filter_${key}`}>
                                <DeletableItem onDelete={() => deleteFilter(index)} className={styles['inlineButton']}>
                                    <SubscriptionFilter
                                        itemKey={`filter_${key}`}
                                        fieldIndex={fieldIndex}
                                        entityIndex={entityIndex}
                                        filterIndex={index}
                                    />
                                </DeletableItem>
                            </FormNamespaceProvider>
                        );
                    })}
                    <SubscriptionAddItemButton onClick={addFilter} label="Add Filter" />
                </FormNamespaceProvider>
            </div>
        </div>
    );
};
